module.exports = __webpack_public_path__ + "static/media/icon-personalize-espaco.42cc6050.svg";